<template>
	<section v-if="streams.length>0" class="posts border-top-none">
		<article v-for="(stream,index) in streams" :key="index">

      <!-- Default text -->
			<header :class="{gridheader:!isSmallTouchDevice()}" v-if="stream.default">
				<span class="date">Demnächst</span>
				<h2>{{stream.title}}</h2>
        <p class="text-center">{{stream.author}}</p>
			</header>
      <!-- Show -->
      <header :class="{gridheader:!isSmallTouchDevice()}" v-else>
				<span class="date">{{getFormatedDate(stream.date,stream.duration)}}</span>
				<h2><router-link :to="'/stream/'+stream.id">{{stream.title}}</router-link></h2>
        <p class="text-center">{{stream.author}}</p>
			</header>

      <RTProjectCover v-if="stream.default" :stream="stream" class="image fit"/>
			<router-link v-else :to="'/stream/'+stream.id">
        <RTProjectCover :stream="stream"/>
      </router-link>
       
			<p :class="{gridbody:!isSmallTouchDevice()}">{{stream.teaser}}</p>
			<ul v-if="!stream.default" class="actions special">
				<li><router-link class="button" :to="'/stream/'+stream.id">Mehr erfahren {{isExternalShop(stream)?" & ansehen":""}}</router-link></li>
			</ul>
		</article>
	</section>
</template>

<script>

import {helper} from '@/mixins/helper.js'
import {shopBase} from '@/mixins/shopBase.js'
import RTProjectCover from '@/components/RTProjectCover.vue'
export default {
  name: 'RTProgram',
  mixins:[helper,shopBase],
  props:{
    upcoming:{
      type:Boolean,
      default:false
    },
    staffel:{
      type:Number,
      default:undefined
    },
    provider:{
      type:String,
      default:null
    },
  },
  components: {
    RTProjectCover
  },
  data: function() {
    return {
    };
  },
  watch:{
  },
  computed:{
    isLoading(){
      return this.$store.state.shops.isLoading;
    },
    streams(){
      if(this.provider){
        return this.getShopsByProvider(this.provider,true);
      }
      return (this.upcoming)?this.getUpcomingShops:this.getPastShops(this.staffel);
    },
  },
  methods:{
  },
  /*
  beforeRouteEnter: (to,from,next) => {
		next(() => {
       setTimeout(()=>{
				window.scrollTo(0, 0);
			},300);
		});
  },
  */
  created() {
  },
  destroyed() {
  },
};
</script>

<style scoped type='text/css'>
.gridheader{
  height: 15rem;
}
.gridbody{
  /*min-height: 16rem;*/
}
</style>